// extracted by mini-css-extract-plugin
module.exports = {"project":"project-module--project--2SK-I","projectButton":"project-module--projectButton--3OGPx","projectTitle":"project-module--projectTitle--2UCXX"};